import darkPalette from "./palette.dark";
import lightPalette from "./palette.light";

export default {
  light: lightPalette,
  dark: darkPalette,
};
